import type { Intent } from './simulation'

const INTENT_KEYS = ['left','right','depthUp','depthDown','block','light','heavy','special','throw','dash','quantum','jump','superJump','flight','boost','dive'] as const satisfies readonly (keyof Intent)[]

export function freshIntent(): Intent {
  return { left:false, right:false, depthUp:false, depthDown:false, block:false, light:false, heavy:false, special:false, throw:false, dash:false, quantum:false, jump:false, superJump:false, flight:false, boost:false, dive:false }
}

/** Clears only canonical gameplay intent fields, preserving adapter metadata. */
export function clearIntent(target: Intent): void {
  for (const key of INTENT_KEYS) target[key] = false
}
